import { useState } from "react";
import {
  FaFileInvoice,
  FaEnvelope,
  FaShieldAlt,
  FaArrowRight,
  FaCheckCircle,
} from "react-icons/fa";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import ApiClient from "../../methods/api/apiClient";
import { useNavigate } from "react-router-dom";
import loader from "../../methods/loader";
import { login_success } from "../../actions/user";
import { useDispatch } from "react-redux";
import { MdOutlineMailOutline } from "react-icons/md";
import { CiGrid41, CiLock, CiMail, CiViewList } from "react-icons/ci";
import { TfiEmail } from "react-icons/tfi";
import { BsGrid, BsLightningCharge } from "react-icons/bs";
import { LuDownload } from "react-icons/lu";
import { GoArrowRight, GoChecklist } from "react-icons/go";
import { SlLock } from "react-icons/sl";
import { IoMailOutline } from "react-icons/io5";
import methodModel from "../../methods/methods";

export default function GuestOrderTracking() {
  const history = useNavigate();

  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [verifiedEmail, setVerifiedEmail] = useState("");
  const dispatch = useDispatch();
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return "Email is required";
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    return "";
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateEmail(email);
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setLoading(true);
    loader(true);

    const res = await ApiClient.post(`user/track/otp/send`, { email });

    loader(false);
    setLoading(false);

    if (res?.success) {
      swal({
        icon: "success",
        title: "Success!",
        text: res?.message,
        confirmButtonColor: "#116DAE",
      }).then(() => {
        setStep("otp");
      });
    } else {
      setError(res?.message || "Failed to send OTP");
    }
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setError("");
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`)?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(pastedData)) return;

    const digits = pastedData.slice(0, otp.length).split("");
    const newOtp = [...otp];

    digits.forEach((digit, index) => {
      newOtp[index] = digit;
    });

    setOtp(newOtp);
    setError("");
    const lastIndex = digits.length - 1;
    document.getElementById(`otp-input-${lastIndex}`)?.focus();
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      setError("Please enter the complete 6-digit OTP");
      return;
    }

    setError("");
    setLoading(true);
    loader(true);

    const res = await ApiClient.post(`user/track/otp/verify`, {
      otp: otpValue,
      email,
    });

    loader(false);
    setLoading(false);

    if (res?.success) {
      setVerifiedEmail(email);
      setStep("success");
      console.log(res.token, "toekn");
      localStorage.setItem("token", res.token);
      //   setTimeout(() => {
      //     fetchQuotes();
      //   }, 300);
      let uUser = {
        // quick_book_companyId: res?.data?.quick_book_companyId,
        // quick_book_accesToken: res?.data?.quick_book_accesToken,
        email: email,
      };
      dispatch(login_success(uUser));
    } else {
      setError(res?.message || "Invalid OTP");
    }
  };

  const fetchQuotes = async () => {
    await ApiClient.get("quickbook/express/tkn")
      .then((res) => {
        if (res?.success) {
          let uUser = {
            quick_book_companyId: res?.data?.quick_book_companyId,
            quick_book_accesToken: res?.data?.quick_book_accesToken,
            email: verifiedEmail,
          };
          dispatch(login_success(uUser));
        }
      })
      .catch(console.error);
  };

  const handleBackToEmail = () => {
    setStep("email");
    setOtp(["", "", "", "", "", ""]);
    setError("");
    setEmail("");
  };

  const handleViewQuotes = () => {
    history("/orders");
  };

  if (step === "email") {
    return (
      <>
        <Header />
        <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px] relative overflow-hidden bg-white">
          <div
            className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #dbeafe 0%, #eff6ff 50%, transparent 70%)",
            }}
          />

          {/* <div
            className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full pointer-events-none"
            style={{ background: "radial-gradient(circle, #dbeafe 0%, #eff6ff 50%, transparent 70%)" }}
          /> */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-40 bg-gradient-to-b from-[#116DAE]/20 to-transparent pointer-events-none" />

          <div
            className="absolute inset-0 pointer-events-none opacity-[0.035]"
            style={{
              backgroundImage:
                "radial-gradient(circle, #116DAE 1.5px, transparent 1.5px)",
              backgroundSize: "32px 32px",
            }}
          />

          <div className="hidden lg:block absolute top-16 right-[42%] w-14 h-14 rounded-full border-2 border-[#116DAE]/15 pointer-events-none" />
          <div className="hidden lg:block absolute top-24 right-[41%] w-6 h-6 rounded-full border border-[#116DAE]/20 pointer-events-none" />
          <div className="hidden lg:block absolute bottom-20 left-[44%] w-10 h-10 rounded-full border border-[#116DAE]/15 pointer-events-none" />
          <div className="hidden lg:block absolute bottom-40 left-16 w-5 h-5 rounded-full bg-[#116DAE]/10 pointer-events-none" />
          <div className="hidden lg:block absolute top-40 left-20 w-3 h-3 rounded-full bg-[#116DAE]/20 pointer-events-none" />

          <div className="relative z-10 min-h-[calc(100vh_-_75px)] ">
            <div className="container mx-auto px-5">
              <div className="flex flex-col lg:flex-row">
                <div className="hidden lg:flex flex-col justify-between w-[48%] xl:w-[45%] px-14 xl:px-20 py-16 relative">
                  <div className="flex items-center gap-3">
                    <h2 class="text-2xl sm:text-3xl font-[600] text-gray-800 tracking-tight">
                      QuoteTracker
                    </h2>
                  </div>

                  <div className="my-auto py-12">
                    {/* <div className="inline-flex items-center gap-2 mb-8">
                      <div className="flex items-center gap-1.5 bg-[#EFF6FF] border border-[#BFDBFE] rounded-full px-3.5 py-1.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#116DAE] animate-pulse" />
                        <span className="text-[#116DAE] text-xs font-semibold">No account required</span>
                      </div>
                    </div> */}

                    <h1
                      className="font-black text-gray-900 tracking-tight leading-[0.95] mb-6"
                      style={{ fontSize: "clamp(3rem, 4.5vw, 4.8rem)" }}
                    >
                      All your
                      <br />
                      <span className="relative inline-block">
                        <span className="relative z-10 text-[#116DAE]">
                          quotes
                        </span>
                        <svg
                          className="absolute -bottom-1 left-0 w-full"
                          height="8"
                          viewBox="0 0 200 8"
                          preserveAspectRatio="none"
                        >
                          <path
                            d="M0 6 Q50 0 100 5 Q150 10 200 4"
                            stroke="#116DAE"
                            strokeWidth="2.5"
                            fill="none"
                            strokeLinecap="round"
                            opacity="0.35"
                          />
                        </svg>
                      </span>
                      <br />
                      one place.
                    </h1>

                    <p className="text-gray-400 text-base leading-relaxed max-w-sm mb-10">
                      Enter your email and get a one-time code to instantly view
                      and manage every quote — beautifully organised.
                    </p>

                    <div className="flex items-center gap-6">
                      {[
                        { val: "2s", label: "Access time" },
                        { val: "100%", label: "Secure" },
                        { val: "0", label: "Passwords" },
                      ].map((s, i) => (
                        <div key={s.label} className="flex items-center gap-6">
                          <div>
                            <p className="text-2xl font-black text-gray-900 leading-none">
                              {s.val}
                            </p>
                            <p className="text-gray-400 text-xs mt-0.5">
                              {s.label}
                            </p>
                          </div>
                          {i < 2 && <div className="w-px h-8 bg-gray-200" />}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex gap-3">
                    {[
                      { icon: <BsLightningCharge />, label: "Instant OTP" },
                      { icon: <GoChecklist />, label: "All Quotes" },
                      // { icon: <LuDownload />, label: "Download" },
                      // { icon: <SlLock />, label: "Encrypted" },
                    ].map((f) => (
                      <div
                        key={f.label}
                        className="flex-1 bg-white border border-gray-200 rounded-2xl px-3 py-3 text-center shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
                      >
                        <div className="flex justify-center text-2xl text-[#116DAE] mb-1">
                          {f.icon}
                        </div>
                        <p className="text-gray-700 text-[10px] font-bold leading-tight">
                          {f.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="hidden lg:flex flex-col items-center justify-center w-px relative">
                  <div className="absolute inset-y-0 w-px bg-gradient-to-b from-transparent via-gray-200 to-transparent" />
                  <div className="relative w-8 h-8 rounded-full bg-white border border-gray-200 shadow flex items-center justify-center z-10">
                    <div className="w-2 h-2 rounded-full bg-[#116DAE]" />
                  </div>
                </div>

                <div className="flex-1 flex flex-col justify-center items-center sm:px-10 md:px-16 lg:px-14 xl:px-20 py-12 lg:py-16">
                  <div className="lg:hidden flex items-center gap-3 mb-10 self-start">
                    <div className="w-9 h-9 rounded-xl bg-[#116DAE] flex items-center justify-center shadow-lg shadow-[#116DAE]/30">
                      <FaFileInvoice className="text-white text-sm" />
                    </div>
                    <span className="text-gray-800 font-bold text-sm">
                      QuoteTracker
                    </span>
                  </div>

                  <div className="w-full max-w-[380px]">
                    <div className="flex items-center gap-3 mb-8">
                      <div className="flex items-center gap-1.5">
                        <div className="w-7 h-7 rounded-full bg-[#116DAE] flex items-center justify-center shadow-md shadow-[#116DAE]/30">
                          <span className="text-white text-[11px] font-black">
                            1
                          </span>
                        </div>
                        <div className="w-10 h-0.5 bg-gray-200 rounded-full" />
                        <div className="w-7 h-7 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center">
                          <span className="text-gray-400 text-[11px] font-bold">
                            2
                          </span>
                        </div>
                      </div>
                      <span className="text-gray-400 text-xs font-medium">
                        Step 1 of 2
                      </span>
                    </div>

                    <h2 className="text-2xl sm:text-3xl font-black text-gray-900 leading-tight mb-1.5">
                      Enter your email
                    </h2>
                    <p className="text-gray-400 text-sm leading-relaxed mb-8">
                      We'll send a quick OTP to verify it's you.
                    </p>

                    <form onSubmit={handleEmailSubmit} className="space-y-4">
                      <div>
                        <label className="block text-sm text-gray-400 mb-2.5">
                          Email Address
                        </label>
                        <div className="relative group">
                          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#116DAE]/20 to-[#1568b3]/20 rounded-2xl opacity-0 group-focus-within:opacity-100 blur transition-opacity duration-300" />
                          <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                              <FaEnvelope className="text-gray-400 text-sm group-focus-within:text-[#116DAE] transition-colors" />
                            </div>
                            <input
                              type="email"
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                setError("");
                              }}
                              placeholder="you@example.com"
                              className="w-full pl-11 pr-4 py-4 bg-gray-50 border-2 border-gray-200 rounded-2xl text-gray-900 placeholder-gray-300 text-sm focus:outline-none focus:border-[#116DAE] focus:bg-white transition-all duration-200 font-medium"
                            />
                          </div>
                        </div>

                        {error && (
                          <div className="mt-2.5 flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#c53030] flex-shrink-0" />
                            <span role="alert" className="text-xs text-[#c53030] font-medium block">
                              {error}
                            </span>
                          </div>
                        )}
                      </div>

                      <button
                        type="submit"
                        disabled={loading}
                        className="relative w-full overflow-hidden group bg-[#116DAE] disabled:opacity-60 disabled:cursor-not-allowed text-white py-4 rounded-2xl text-sm font-bold flex items-center justify-center gap-2.5 transition-all duration-200 active:scale-[0.98] shadow-xl shadow-[#116DAE]/25 hover:shadow-2xl hover:shadow-[#116DAE]/35 hover:bg-[#0e4d87]"
                      >
                        <div className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12" />
                        {loading ? (
                          <>
                            <svg
                              className="animate-spin w-4 h-4"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              />
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v8z"
                              />
                            </svg>
                            Sending OTP...
                          </>
                        ) : (
                          <>
                            Continue
                            <svg
                              className="w-4 h-4 group-hover:translate-x-0.5 transition-transform"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2.5}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M17 8l4 4m0 0l-4 4m4-4H3"
                              />
                            </svg>
                          </>
                        )}
                      </button>
                    </form>

                    <div className="mt-6 flex items-center justify-center gap-2">
                      <div className="flex-1 h-px bg-gray-200" />
                      <p className="text-gray-400 text-xs px-3 whitespace-nowrap">
                        No account needed
                      </p>
                      <div className="flex-1 h-px bg-gray-200" />
                    </div>

                    <div className="lg:hidden mt-6 flex flex-wrap gap-2 justify-center">
                      {["⚡ Instant OTP", "📋 All Quotes"].map((t) => (
                        <span
                          key={t}
                          className="text-xs text-gray-500 bg-gray-100 rounded-full px-3 py-1.5"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {methodModel.TokenChecker() && <Footer />}
      </>
    );
  }

  if (step === "otp") {
    return (
      <>
        <Header />
        <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px] relative overflow-hidden bg-white">
          <div
            className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(circle, #dbeafe 0%, #eff6ff 50%, transparent 70%)",
            }}
          />
          {/* <div
            className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full pointer-events-none"
            style={{ background: "radial-gradient(circle, #dbeafe 0%, #eff6ff 50%, transparent 70%)" }}
          /> */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-40 bg-gradient-to-b from-[#116DAE]/20 to-transparent pointer-events-none" />

          <div
            className="absolute inset-0 pointer-events-none opacity-[0.035]"
            style={{
              backgroundImage:
                "radial-gradient(circle, #116DAE 1.5px, transparent 1.5px)",
              backgroundSize: "32px 32px",
            }}
          />

          <div className="hidden lg:block absolute top-16 right-[42%] w-14 h-14 rounded-full border-2 border-[#116DAE]/15 pointer-events-none" />
          <div className="hidden lg:block absolute top-24 right-[41%] w-6 h-6 rounded-full border border-[#116DAE]/20 pointer-events-none" />
          <div className="hidden lg:block absolute bottom-20 left-[44%] w-10 h-10 rounded-full border border-[#116DAE]/15 pointer-events-none" />
          <div className="hidden lg:block absolute bottom-40 left-16 w-5 h-5 rounded-full bg-[#116DAE]/10 pointer-events-none" />
          <div className="hidden lg:block absolute top-40 left-20 w-3 h-3 rounded-full bg-[#116DAE]/20 pointer-events-none" />

          <div className="relative z-10 min-h-[calc(100vh_-_75px)]">
            <div className="container mx-auto px-5">
              <div className="flex flex-col lg:flex-row">
                <div className="hidden lg:flex flex-col justify-between w-[48%] xl:w-[45%] px-14 xl:px-20 py-16 relative">
                  <div className="flex items-center gap-3">
                    <h2 class="text-2xl sm:text-3xl font-[600] text-gray-800 tracking-tight">
                      QuoteTracker
                    </h2>
                  </div>

                  {/* <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-xl bg-[#116DAE] flex items-center justify-center shadow-lg shadow-[#116DAE]/30">
                      <FaFileInvoice className="text-white text-sm" />
                    </div>
                    <span className="text-gray-800 font-bold text-sm tracking-tight">QuoteTracker</span>
                  </div> */}

                  <div className="my-auto py-12">
                    {/* 
                    <div className="inline-flex items-center gap-2 mb-8">
                      <div className="flex items-center gap-1.5 bg-[#EFF6FF] border border-[#BFDBFE] rounded-full px-3.5 py-1.5">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#116DAE] animate-pulse" />
                        <span className="text-[#116DAE] text-xs font-semibold">Almost there</span>
                      </div>
                    </div> */}

                    <h1
                      className="font-black text-gray-900 tracking-tight leading-[0.95] mb-6"
                      style={{ fontSize: "clamp(3rem, 4.5vw, 4.8rem)" }}
                    >
                      Check your
                      <br />
                      <span className="relative inline-block">
                        <span className="relative z-10 text-[#116DAE]">
                          inbox
                        </span>
                        <svg
                          className="absolute -bottom-1 left-0 w-full"
                          height="8"
                          viewBox="0 0 200 8"
                          preserveAspectRatio="none"
                        >
                          <path
                            d="M0 6 Q50 0 100 5 Q150 10 200 4"
                            stroke="#116DAE"
                            strokeWidth="2.5"
                            fill="none"
                            strokeLinecap="round"
                            opacity="0.35"
                          />
                        </svg>
                      </span>
                      <br />
                      right now.
                    </h1>

                    <p className="text-gray-400 text-base leading-relaxed max-w-sm mb-10">
                      We sent a 6-digit code to{" "}
                      <span className="font-semibold text-gray-600">
                        {email}
                      </span>
                      . Enter it to securely access all your quotes.
                    </p>

                    <div className="flex items-center gap-6">
                      {[
                        { val: "15m", label: "Code expires" },
                        { val: "6", label: "Digit code" },
                        { val: "1×", label: "Use only" },
                      ].map((s, i) => (
                        <div key={s.label} className="flex items-center gap-6">
                          <div>
                            <p className="text-2xl font-black text-gray-900 leading-none">
                              {s.val}
                            </p>
                            <p className="text-gray-400 text-xs mt-0.5">
                              {s.label}
                            </p>
                          </div>
                          {i < 2 && <div className="w-px h-8 bg-gray-200" />}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex gap-3">
                    {[
                      { icon: <IoMailOutline />, label: "Check Inbox" },
                      { icon: <BsGrid />, label: "Enter Code" },
                      // { icon: <GoChecklist />, label: "View Quotes" },
                      // { icon: <SlLock />, label: "Encrypted" },
                    ].map((f) => (
                      <div
                        key={f.label}
                        className="flex-1 bg-white border border-gray-200 rounded-2xl px-3 py-3 text-center shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
                      >
                        <div className="flex justify-center text-2xl text-[#116DAE] mb-1">
                          {f.icon}
                        </div>
                        <p className="text-gray-700 text-[10px] font-bold leading-tight">
                          {f.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="hidden lg:flex flex-col items-center justify-center w-px relative">
                  <div className="absolute inset-y-0 w-px bg-gradient-to-b from-transparent via-gray-200 to-transparent" />
                  <div className="relative w-8 h-8 rounded-full bg-white border border-gray-200 shadow flex items-center justify-center z-10">
                    <div className="w-2 h-2 rounded-full bg-[#116DAE]" />
                  </div>
                </div>

                <div className="flex-1 flex flex-col justify-center items-center sm:px-10 md:px-16 lg:px-14 xl:px-20 py-12 lg:py-16">
                  <div className="lg:hidden flex items-center gap-3 mb-10 self-start">
                    <div className="w-9 h-9 rounded-xl bg-[#116DAE] flex items-center justify-center shadow-lg shadow-[#116DAE]/30">
                      <FaFileInvoice className="text-white text-sm" />
                    </div>
                    <span className="text-gray-800 font-bold text-sm">
                      QuoteTracker
                    </span>
                  </div>

                  <div className="w-full max-w-[380px]">
                    <div className="flex items-center gap-3 mb-8">
                      <div className="flex items-center gap-1.5">
                        <div className="w-7 h-7 rounded-full bg-[#116DAE]/15 border border-[#116DAE]/30 flex items-center justify-center">
                          <svg
                            className="w-3.5 h-3.5 text-[#116DAE]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={3}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                        <div className="w-10 h-0.5 bg-[#116DAE]/40 rounded-full" />
                        <div className="w-7 h-7 rounded-full bg-[#116DAE] flex items-center justify-center shadow-md shadow-[#116DAE]/30">
                          <span className="text-white text-[11px] font-black">
                            2
                          </span>
                        </div>
                      </div>
                      <span className="text-gray-400 text-xs font-medium">
                        Step 2 of 2
                      </span>
                    </div>

                    <h2 className="text-2xl sm:text-3xl font-black text-gray-900 leading-tight mb-1.5">
                      Verify your email
                    </h2>
                    <p className="text-gray-400 text-sm leading-relaxed mb-8">
                      Enter the 6-digit code we sent to{" "}
                      <span className="font-semibold text-gray-700">
                        {email}
                      </span>
                    </p>

                    <form onSubmit={handleOtpSubmit} className="space-y-4">
                      <div>
                        <label className="block text-sm text-gray-400 mb-2.5">
                          Verification Code
                        </label>

                        <div className="flex gap-2.5">
                          {otp.map((digit, index) => (
                            <div key={index} className="relative group flex-1">
                              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#116DAE]/20 to-[#1568b3]/20 rounded-2xl opacity-0 group-focus-within:opacity-100 blur transition-opacity duration-300" />
                              <input
                                id={`otp-input-${index}`}
                                type="text"
                                inputMode="numeric"
                                maxLength={1}
                                value={digit}
                                onChange={(e) =>
                                  handleOtpChange(index, e.target.value)
                                }
                                onPaste={handleOtpPaste}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" &&
                                    !otp[index] &&
                                    index > 0
                                  ) {
                                    document
                                      .getElementById(`otp-input-${index - 1}`)
                                      ?.focus();
                                  }
                                }}
                                className="relative w-full h-14 text-center text-xl font-black bg-gray-50 border-2 border-gray-200 rounded-2xl text-gray-900 focus:outline-none focus:border-[#116DAE] focus:bg-white transition-all duration-200"
                                autoFocus={index === 0}
                              />
                            </div>
                          ))}
                        </div>

                        {error && (
                          <div className="mt-2.5 flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#c53030] flex-shrink-0" />
                            <span role="alert" className="text-xs text-[#c53030] font-medium block">
                              {error}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-wrap gap-2">
                        {["Expires in 15 min", "Check spam too"].map((hint) => (
                          <span
                            key={hint}
                            className="text-[11px] text-gray-400 bg-gray-100 rounded-full px-3 py-1 font-medium"
                          >
                            {hint}
                          </span>
                        ))}
                      </div>

                      <button
                        type="submit"
                        disabled={loading}
                        className="relative w-full overflow-hidden group bg-[#116DAE] disabled:opacity-60 disabled:cursor-not-allowed text-white py-4 rounded-2xl text-sm font-bold flex items-center justify-center gap-2.5 transition-all duration-200 active:scale-[0.98] shadow-xl shadow-[#116DAE]/25 hover:shadow-2xl hover:shadow-[#116DAE]/35 hover:bg-[#0e4d87]"
                      >
                        <div className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12" />
                        {loading ? (
                          <>
                            <svg
                              className="animate-spin w-4 h-4"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              />
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v8z"
                              />
                            </svg>
                            Verifying...
                          </>
                        ) : (
                          <>
                            Verify & Continue
                            <FaCheckCircle className="text-sm" />
                          </>
                        )}
                      </button>
                    </form>

                    <div className="mt-6 flex items-center justify-center gap-2">
                      <div className="flex-1 h-px bg-gray-200" />
                      <p className="text-gray-400 text-xs px-3 whitespace-nowrap">
                        One-time use only
                      </p>
                      <div className="flex-1 h-px bg-gray-200" />
                    </div>

                    <div className="mt-5 flex justify-center">
                      <button
                        onClick={handleBackToEmail}
                        className="text-xs text-gray-400 hover:text-[#116DAE] transition-colors flex items-center gap-1.5"
                      >
                        <svg
                          className="w-3.5 h-3.5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M10 19l-7-7m0 0l7-7m-7 7h18"
                          />
                        </svg>
                        Use a different email
                      </button>
                    </div>

                    <div className="lg:hidden mt-6 flex flex-wrap gap-2 justify-center">
                      {["📬 Check Inbox", "🔢 Enter Code", "🔒 Encrypted"].map(
                        (t) => (
                          <span
                            key={t}
                            className="text-xs text-gray-500 bg-gray-100 rounded-full px-3 py-1.5"
                          >
                            {t}
                          </span>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {methodModel.TokenChecker() && <Footer />}
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-[calc(100vh_-_75px)] md:min-h-[calc(100vh_-_95px)] mt-[75px] lg:mt-[95px] bg-gradient-to-br from-gray-50 to-white relative">
        <div
          className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, #dbeafe 0%, #eff6ff 50%, transparent 70%)",
          }}
        />

        {/* <div
            className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full pointer-events-none"
            style={{ background: "radial-gradient(circle, #dbeafe 0%, #eff6ff 50%, transparent 70%)" }}
          /> */}

        <div
          className="absolute inset-0 pointer-events-none opacity-[0.035]"
          style={{
            backgroundImage:
              "radial-gradient(circle, #116DAE 1.5px, transparent 1.5px)",
            backgroundSize: "32px 32px",
          }}
        />
        <div className="hidden lg:block absolute top-16 right-[42%] w-14 h-14 rounded-full border-2 border-[#116DAE]/15 pointer-events-none" />
        <div className="hidden lg:block absolute top-24 right-[41%] w-6 h-6 rounded-full border border-[#116DAE]/20 pointer-events-none" />
        <div className="hidden lg:block absolute bottom-20 left-[44%] w-10 h-10 rounded-full border border-[#116DAE]/15 pointer-events-none" />
        <div className="hidden lg:block absolute bottom-40 left-16 w-5 h-5 rounded-full bg-[#116DAE]/10 pointer-events-none" />
        <div className="hidden lg:block absolute top-40 left-20 w-3 h-3 rounded-full bg-[#116DAE]/20 pointer-events-none" />
        <div className="relative z-10">
          <div className="container mx-auto px-6 py-16 md:py-24">
            <div className="max-w-lg mx-auto">
              <div className="bg-white rounded-3xl text-center shadow-lg">
                <div className="px-5 py-8 sm:p-8">
                  <div className="w-[120px] h-[120px] rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6 shadow-md">
                    <img
                      src="/assets/img/success.gif"
                      className="w-full h-full object-contain"
                      alt="Success"
                    />
                  </div>

                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                    Verification Successful!
                  </h2>
                  <p className="text-sm text-gray-600 mb-8">
                    Your email has been verified successfully. Now you can
                    proceed to your quotes.
                  </p>

                  <div className="bg-gray-50 rounded-xl p-5 mb-8 shadow-sm">
                    <p className="text-sm text-gray-600 mb-2">Verified Email</p>
                    <p className="text-md font-semibold text-gray-900">
                      {verifiedEmail}
                    </p>
                  </div>

                  <button
                    onClick={handleViewQuotes}
                    className="relative w-full overflow-hidden group bg-[#116DAE] disabled:opacity-60 disabled:cursor-not-allowed text-white py-4 rounded-2xl text-sm font-bold flex items-center justify-center gap-2.5 transition-all duration-200 active:scale-[0.98] shadow-xl shadow-[#116DAE]/25 hover:shadow-2xl hover:shadow-[#116DAE]/35 hover:bg-[#0e4d87]"
                  >
                    <div className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12" />
                    View My Quotes
                    <GoArrowRight className="text-lg" />
                  </button>
                  <div className="mt-5 flex justify-center">
                    <button
                      onClick={handleBackToEmail}
                      className="text-xs text-gray-400 hover:text-[#116DAE] transition-colors flex items-center gap-1.5"
                    >
                      <svg
                        class="w-3.5 h-3.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M10 19l-7-7m0 0l7-7m-7 7h18"
                        ></path>
                      </svg>
                      Track Another Email
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {methodModel.TokenChecker() && <Footer />}
    </>
  );
}
